import React, { useEffect } from "react";
import { createData } from "../../utility/managerApi";
import CancelIcon from "@mui/icons-material/Cancel";

function EditProfile({
  singleData,
  setSingleData,
  fetchProfile,
  setEdittab,
  //   setLoading,
}) {
  const roleId = singleData?.roles[0]?.id;
  // const [loading, setLoading] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target; // Destructure name and value from event target
    setSingleData((prevData) => ({
      ...prevData,
      [name]: value, // Update the corresponding field in state
    }));
  };
  const roleidSet = (id) => {
    setSingleData((prevData) => ({ ...prevData, role_id: id }));
  };

  useEffect(() => {
    roleidSet(roleId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleEditSubmit = async (e) => {
    e.preventDefault();

    // Log singleData before submission to check its content

    const keysToExtract = [
      "role_id",
      "firstname",
      "lastname",
      "email",
      "address",
      "phoneno",
      "profile_image",
      "old_password",
      "new_password",
    ];
    const newSingleData = Object.keys(singleData).reduce((result, key) => {
      if (keysToExtract.includes(key)) {
        result[key] = singleData[key];
      }

      return result;
    }, {});

    const response = await createData("users/profile_update", newSingleData);
    let errorCheck = response?.response?.data?.error;

    if (errorCheck) {
    } else {
      fetchProfile();
      setEdittab(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-md">
      <div className="flex justify-end">
        <CancelIcon
          className="cursor-pointer"
          onClick={() => setEdittab(false)}
        />
      </div>

      <h2 className="text-2xl font-medium text-center">Edit Profile </h2>
      <form
        onSubmit={handleEditSubmit}
        className="py-12  flex flex-col justify-center items-center gap-6 "
      >
        <div className="flex flex-col  lg:flex-row flex-wrap justify-center gap-6 ">
          <div className="flex flex-col">
            <label htmlFor="">First Name</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="First name"
              type="text "
              name="firstname"
              // id="email"
              value={singleData.firstname}
              onChange={handleChange}
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="">Last Name</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="Last Name"
              type="text "
              name="lastname"
              // id="email"
              value={singleData.lastname}
              onChange={handleChange}
              required
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="">Email</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="Email"
              type="email"
              name="email"
              // id="email"
              value={singleData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="">Address</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="Address"
              type="text "
              name="address"
              // id="email"
              value={singleData.address}
              onChange={handleChange}
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="">Old password</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md focus:border-gray-500 focus:outline-none lg:w-[400px]"
              placeholder="Old password"
              type="password"
              // id="email"
              name="old_password"
              value={singleData.old_password}
              onChange={handleChange}
              required
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="">New password</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md focus:border-gray-500 focus:outline-none lg:w-[400px]"
              placeholder="New password"
              type="password"
              // id="email"
              name="new_password"
              value={singleData.new_password}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <button
          // disabled={loading}
          type="submit"
          className="px-4 py-3 text-white rounded-lg w-full lg:w-[400px] bg-blue-500"
        >
          {/* {loading ? "Saving..." : "Save Product"} */}
          Submit
        </button>
      </form>
    </div>
  );
}

export default EditProfile;
